import React from 'react';

export function WelcomeMessageSkeleton() {
  return (
    <div className="flex justify-between items-center mb-6 will-change-opacity">
      <div className="h-10 w-64 bg-gray-200 rounded-md animate-pulse"></div>
      <div className="h-8 w-24 bg-gray-200 rounded-md animate-pulse"></div>
    </div>
  );
}
